import apiCall from 'apps/investment/apiCalls/user-ekyc-records';
import { DetailPage, ListPage } from 'common/ui/admin-CRUD/page';
import { useParams } from 'react-router-dom';
import { columnsGenerator } from './config';
import ItemDetail from './detail';

export const UserEkycRecordsListPage = () => (
  <ListPage
    title="User EKYC Records"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
  />
);

export const UserEkycRecordsDetailPage = () => {
  const { userId } = useParams();

  return (
    <DetailPage
      title="EKYC Record"
      apiCall={apiCall}
      listUrl={`/investment/users/${userId}/user-ekyc-records`}
      ItemDetail={ItemDetail}
      options={{ editEnabled: false }}
    />
  );
};
